import React from "react";
import "./DataIntegrity.css";
import Shape1 from "../../../../assets/images/dataintegrity-shape1.png";
import Shape2 from "../../../../assets/images/dataintegrity-shape2.png";
import Shape3 from "../../../../assets/images/dataintegrity-shape3.png";
import Dots from "../../../../assets/images/aboutus-dots.png";
const DataIntegrity = () => {
  return (
    <div className="data__integrity_section">
      <img src={Shape1} alt="" className="data__integsec_shape1" />
      <img src={Shape2} alt="" className="data__integsec_shape2" />
      <img src={Shape3} alt="" className="data__integsec_shape3" />
      <img src={Dots} alt="" className="data__integsec_dots" />
      <div className="data__integsec_heading">Client Data Integrity</div>
      <div className="data__integsec_description">
        Data integrity is a fundamental component of Serene Tax. It is mandatory
        to keep your data and information safe and secure. Clients information
        are not used for any misappropriate use. You can rely on us for 100%
        data integrity.
      </div>
    </div>
  );
};

export default DataIntegrity;
